function Footer(){
    return(
        <div className="border-t-black border-t-[1px] mt-32 text-xs sm:text-base font-body p-4 flex justify-center">
            Made with❤️by:<a href="https://github.com/crsdvaibhav" target="_blank" className="px-2 hover:animate-spin">Vaibhav</a> (hover over it)
        </div>
    )
}

export default Footer;